import { ENTRY_MARKER } from "./positionConstants";

// Index of the last bar that opened at or before `time`; bars are sorted by time
const findBarIndex = (bars, time) => {
  let low = 0;
  let high = bars.length - 1;

  while (low < high) {
    const middle = Math.ceil((low + high) / 2);

    if (bars[middle].time <= time) low = middle;
    else high = middle - 1;
  }

  return low;
};

/**
 * Small ▲ in the entry colour under the bar each position was opened on
 * (moon-position-lines-spec.md, «Лінія входу»). Nothing when the open time
 * is unknown, outside the loaded bars or the bar is out of view.
 *
 * @param {object} textLayer
 * @param {Array<{ entry: { time: number|null } }>} positions
 * @param {object} params
 * @param {object} params.store - BarStore
 * @param {number} params.barDurationMs
 * @param {object} params.series - mainSeries: the drawn low of the bar
 * @param {object} params.timeScale
 * @param {object} params.priceScale
 * @param {{ width: number, height: number }} params.pane
 * @param {string} params.color - CSS colour
 */
export const drawEntryMarkers = (
  textLayer,
  positions,
  { store, barDurationMs, series, timeScale, priceScale, pane, color },
) => {
  const { bars } = store;
  const { context } = textLayer;

  if (!bars.length) return;

  const firstTime = bars[0].time;
  const endTime = bars[bars.length - 1].time + barDurationMs;

  positions.forEach(({ entry }) => {
    if (entry.time == null || entry.time < firstTime || entry.time >= endTime) return;

    const index = findBarIndex(bars, entry.time);
    const x = timeScale.indexToX(index);
    const low = series.extremes(index, index)?.low.price;

    if (low == null || x < 0 || x > pane.width) return;

    const top = priceScale.priceToY(low) + ENTRY_MARKER.gap;

    if (top + ENTRY_MARKER.height > pane.height) return;

    context.beginPath();
    context.moveTo(x, top);
    context.lineTo(x + ENTRY_MARKER.width / 2, top + ENTRY_MARKER.height);
    context.lineTo(x - ENTRY_MARKER.width / 2, top + ENTRY_MARKER.height);
    context.closePath();
    context.fillStyle = color;
    context.fill();
  });
};
